import { MONTH_OPTIONS, YEAR_OPTIONS } from '../../utils/registrationFormDropdownOptions';
export function isValueAnOption(value, options) {
  return typeof options.find(opt => opt.value === value || '') !== 'undefined';
}
export const monthValidator = {
  message: 'Please enter a valid Month of Birth',
  callback: value => isValueAnOption(value, MONTH_OPTIONS)
};
export const yearValidator = {
  message: 'Please enter a valid Year of Birth',
  callback: value => isValueAnOption(value, YEAR_OPTIONS)
};